module.exports = __webpack_public_path__ + "static/media/Avenir-Medium-01.ea764094.svg";